import script from "./ScanCodeActivation.vue?vue&type=script&setup=true&lang=js"
export * from "./ScanCodeActivation.vue?vue&type=script&setup=true&lang=js"

import "./ScanCodeActivation.vue?vue&type=style&index=0&id=4832c23d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4832c23d"]])

export default __exports__